module.exports = __webpack_public_path__ + "img/126.7f2eeeb4.jpg";